// extracted by mini-css-extract-plugin
export default {"container":"cover_container__aehCU","transparent":"cover_transparent__gh4Pk"};